import React from "react"
import News from "../../blocks/news"
import { graphql } from "gatsby"

export const pageQuery = graphql`
query {
  news: newsYaml(slug: { eq: "sorokins_latvia_2" }) {
    ...NewsInfo
  }
}`

export default class NewsText extends News {
  renderNews() {
    return (
      <div className="row">
        <div className="col-xl-12">
          <p>Защитник рижского ФК РФШ Владиславс Сорокинс вызван в национальную сборную Латвии для участия в двух официальных матчах Лиге Наций. Соперниками сборной Латвии будут сборные Андорры и Мальты.</p>
        </div>
      </div>
    )
  }
}